import { Stack, Text } from '@chakra-ui/react'

export default function ActivityModalItem({
  title,
  description,
}: {
  title: string
  description: string | (() => React.ReactNode)
}): JSX.Element {
  return (
    <Stack direction="column" spacing={2}>
      <Text fontWeight={600}>{title}</Text>
      {typeof description === 'function' ? description() : <Text>{description}</Text>}
    </Stack>
  )
}
